import React from 'react';
import styled from 'styled-components';
import TdaCategoryTree from '../../Components/TdaCategoryTree';
import qs from 'query-string';
import * as NavUtil from '../../Utils/NavUtil';
import useArea from '../../Hooks/useArea';

export default function ListLayout(props) {
  const {categories_key} = props.pageContext;

  const siteConfig = props.pageContext.prebuiltSiteConfig[categories_key];
  const categories = siteConfig?.categories;
  const params = qs.parse(props.location.search) || {};
  const {isPeople, isDoctor} = useArea();
  const navItems = NavUtil.getNavItems({...props, isDoctor});
  const navItem = navItems.find((item) => NavUtil.isNavLinkSelected(item));
  const subItemNames = (navItem?.entries || []).map((x) => x.name);

  return (
    <Wrapper>
      <main className="tda-layout">
        <section className="nav">
          {Array.isArray(categories) ? (
            <TdaCategoryTree
              title={navItem?.name}
              root={{
                categories: categories
                  .filter((c) =>
                    isDoctor ? true : subItemNames.includes(c.name),
                  )
                  .map((c) => ({
                    ...c,
                    url: props.location.pathname + `?cat=${c.name}`,
                  })),
              }}
              location={props.location}
              checkSelected={({name}) => name === params.cat}
            />
          ) : (
            <div>顯示錯誤</div>
          )}
        </section>
        <section className="content">{props.children}</section>
      </main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);
`;
